export const CUSTOMER_SUCCESS = {
  ADD_TENANT: 'Añadir tenant',
  TENANT_CREATED: 'Tenant creado',
  SEARCH_PLACEHOLDER: 'Buscar tenants o Security Managers',
  ALL: 'Todos',
  FILTER_BY_SECURITY_MANAGER: 'Filtrar por Security Manager',
  FILTER_BY_STANDARD: 'Filtrar por estándar',
  UNASSIGNED: 'Sin asignar',
  NOT_SET: 'sin fecha',
  IN_PROGRESS: 'En curso',
  DAYS: (days: number) => `${days} días`,
  INTERNAL: 'Interna',
  EXTERNAL: 'Externa',
  SUBTITLE:
    'Estado de implantación de cada tenant: capacidades activas, tiempo de onboarding, tiempo hasta auditoría y tasa de adopción',
  TABS: { KPIS: 'KPIs', TENANTS: 'Tenants' },
  KPIS: {
    ACTIVE_ACCOUNTS: 'Cuentas activas',
    ACTIVE_ACCOUNTS_DETAIL: (live: number, followUp: number) => `${live} live · ${followUp} en seguimiento`,
    CLIENTS_PER_SECURITY_MANAGER: 'Clientes por Security Manager',
    SECURITY_MANAGERS_DETAIL: (count: number, top: string, accounts: number) =>
      `${count} Security Managers · top ${top} con ${accounts}`,
    ARR: 'ARR',
    ARR_DETAIL: (arr: string) => `${arr} por Security Manager`,
    AVG_ONBOARDING_TIME: 'Tiempo medio de onboarding',
    ONBOARDING_DETAIL: (onboarded: number, total: number, target: number) =>
      `${onboarded} de ${total} con onboarding completo · objetivo ${target} días`,
    AVG_TIME_TO_AUDIT: 'Tiempo medio hasta auditoría',
    TIME_TO_AUDIT_DETAIL: 'Desde el onboarding hasta la primera auditoría interna',
    AVG_ADOPTION_RATE: 'Tasa de adopción media',
    ADOPTION_DETAIL: 'Capacidades en alcance activadas y en uso',
    ARR_PER_SECURITY_MANAGER: 'ARR por Security Manager',
    ACCOUNTS_PER_SECURITY_MANAGER: 'Cuentas por Security Manager',
    ACCOUNTS: 'Cuentas',
    AVG_ADOPTION: (rate: number) => `${rate}% adopción media`,
    NO_SECURITY_MANAGERS: 'Sin Security Managers asignados',
  },
  DRAWER: {
    ATTRIBUTES: 'Atributos',
    DATES: 'Fechas',
    METRICS: 'Métricas',
    ONBOARDING_TIME_INFO:
      'Días hasta que todas las capacidades en alcance tienen su primer resultado (un escaneo o datos cargados).',
    ADOPTION_RATE_INFO: 'Porcentaje de capacidades en alcance activadas y usadas en los últimos 7 días.',
    NOTES: 'Notas',
    NO_NOTES: 'Sin notas',
    OVERVIEW: 'Resumen',
    CAPABILITIES: 'Capacidades',
    TIMELINES: 'Cronogramas',
    SHOW_ON_HOME: 'Mostrar en inicio',
    MILESTONES: (count: number) => (count === 1 ? '1 hito' : `${count} hitos`),
    MILESTONE_NAME: 'Nombre',
    MILESTONE_DATE: 'Fecha',
    ADD_MILESTONE: 'Añadir hito',
    REMOVE_MILESTONE: 'Quitar hito',
    NO_STANDARDS: 'Sin estándares',
    SECTION: 'Sección',
    IN_SCOPE: 'En alcance',
    ACTIVE: 'Activa',
    RESULT_LOADED: 'Resultado cargado',
    NO_RESULT: 'Sin resultado',
    CLIENT_ACTIVITY: 'Actividad del cliente',
    ACTIVITY_STATUS: { inUse: 'En uso', atRisk: 'En riesgo', off: 'Inactiva' },
    LAST_ACCESS: (days: number) => (days === 0 ? 'Hoy' : `Hace ${days} d`),
    NEVER_ACCESSED: 'Sin accesos',
    NEVER_EDITED: 'Sin ediciones',
    PAGE_LAST_ACCESS: 'Último acceso',
    PAGE_LAST_EDIT: 'Última edición',
    CAPABILITY_NOT_ACTIVE: 'Capacidad no activa',
    LOGO: 'Logo',
    UPLOAD_LOGO: 'Subir logo',
    LANGUAGE: 'Idioma',
    DOMAINS: 'Dominios',
    TEXT_EDITOR: 'Documentos del editor de texto',
    TEXT_EDITOR_INFO:
      'Sirve las políticas desde el editor de texto integrado en lugar de Google Drive. Los documentos no muestran versiones hasta que se aprovisionan por separado.',
    TIME_TO_RESOLVE: 'Tiempo de resolución',
    TIME_TO_RESOLVE_INFO: 'Muestra en el detalle de los hallazgos cerrados cuánto tardaron en resolverse.',
    DEMO: 'Demo',
    IS_DEMO: 'Organización demo',
    IS_DEMO_INFO:
      'Marca esta organización como un tenant demo para aplicar datos semilla y funciones exclusivas de demo.',
    CONTACT_EMAIL: 'Email de contacto',
    ONBOARDING_DATE: 'Fecha de onboarding',
    INTERNAL_AUDIT: 'Auditoría interna',
    EXTERNAL_AUDIT: 'Auditoría externa',
    NOT_SET: 'Sin definir',
    EDIT_STANDARDS: 'Editar estándares',
    REMOVE_STANDARDS_WARNING: (standards: string) =>
      `Quitar ${standards} elimina sus controles, documentos y evidencias de este tenant. No se puede deshacer.`,
    SAVE: 'Guardar',
    CANCEL: 'Cancelar',
    MDM: {
      TAB: 'MDM',
      NOT_SET_UP: 'MDM sin configurar',
      SET_UP: 'Configurar MDM',
      SET_UP_AGAIN: 'Volver a configurar',
      ENABLED: 'MDM activado',
      STEPS: {
        TEAM: {
          TITLE: 'Configura el equipo en el servidor MDM',
          TASKS: {
            CREATE_TEAM: 'Crea un equipo para este tenant',
            COPY_TEAM_ID: 'Copia su ID de equipo en el campo de abajo',
            CREATE_USER: 'Crea un usuario administrador solo API para ese equipo',
            COPY_TOKEN: 'Copia el token API de ese usuario',
          },
        },
        SECRET: {
          TITLE: 'Guarda el token en AWS',
          DESCRIPTION: 'Crea un secreto en AWS Secrets Manager con este contenido',
        },
        LINK: { TITLE: 'Vincula el secreto', DESCRIPTION: 'Pega el ARN de ese secreto y guarda' },
      },
      TEAM_ID: 'ID del equipo en Fleet',
      TEAM_ID_PLACEHOLDER: '<ID del equipo>',
      TOKEN_PLACEHOLDER: '<token API>',
      COPY: 'Copiar',
      SECRET_REF: 'ARN del secreto',
      SECRET_REF_PLACEHOLDER: 'arn:aws:secretsmanager:...',
      LIBRARY: {
        TITLE: 'Biblioteca de Qalea',
        ADD: 'Añadir política',
        NEW_TITLE: 'Nueva política de la biblioteca',
        EDIT_TITLE: 'Editar política de la biblioteca',
        EMPTY: 'Sin políticas en la biblioteca',
        SAVE: 'Guardar',
        CANCEL: 'Cancelar',
        EDIT: 'Editar',
        DELETE: 'Eliminar',
        DELETE_TITLE: 'Eliminar política de la biblioteca',
        DELETE_DESCRIPTION: (name: string) =>
          `${name} se elimina para este cliente, y de sus dispositivos si la desplegó.`,
        SAVED: 'Política de la biblioteca guardada',
        DELETED: 'Política de la biblioteca eliminada',
      },
    },
    PHISHING_IMPORT: {
      TAB: 'Phishing',
      IMPORT: 'Importar campaña',
      CONFIRM: 'Importar',
      CANCEL: 'Cancelar',
      CAMPAIGN: 'Campaña',
      LAUNCH_DATE: 'Fecha de lanzamiento',
      PICK_DATE: 'Elige una fecha',
      TARGETED: 'Destinatarios',
      TARGETED_COUNT: (count: number) => `${count} destinatarios`,
      NO_CAMPAIGNS: 'Sin campañas importadas',
      SEARCH: 'Buscar campañas',
      NO_RESULTS: 'No hay campañas',
      LOADING_CAMPAIGNS: 'Cargando campañas de CanIPhish…',
      IMPORTING: 'Importando la campaña desde CanIPhish…',
      IMPORTING_HINT: 'Puede tardar hasta un minuto. No cierres esta ventana.',
      IMPORTING_BUTTON: 'Importando…',
      SUGGESTED: 'Sugerida',
      IMPORTED: 'Importada',
      TEMPLATE: 'Plantilla',
      TEMPLATE_MISSING: 'Falta',
      UPLOAD_TEMPLATE: 'Subir plantilla',
      EMAIL_SCREENSHOT: 'Captura del email',
      LANDING_SCREENSHOT: 'Captura de la landing (opcional)',
      UPLOAD: 'Subir',
      UPLOADING: 'Subiendo…',
      TOAST_TEMPLATE_UPLOADED: (name: string) => `Plantilla ${name} vinculada`,
      TOAST_SUCCESS: ({ matched, unmatched }: { matched: number; unmatched: number }) =>
        `${matched} resultados importados${unmatched ? `, ${unmatched} sin empleado` : ''}`,
    },
    SEED_DEMO: {
      BUTTON_LABEL: 'Cargar datos de demo',
      BUTTON_TOOLTIP: 'Requiere que Acme Corporation tenga riesgos y no conformidades cargados en este entorno.',
      CONFIRM_TITLE: '¿Cargar datos de demo para esta organización?',
      CONFIRM_DESCRIPTION:
        'Se crearán empleados, riesgos, no conformidades y accesos SaaS de demo para esta organización. Las partes que ya existan se omitirán.',
      CONFIRM_ACTION: 'Cargar',
      CONFIRM_CANCEL: 'Cancelar',
      TOAST_SUCCESS: ({
        employees,
        risks,
        nonConformities,
        documents,
        saas,
        skippedList,
      }: {
        employees: number
        risks: number
        nonConformities: number
        documents: number
        saas: number
        skippedList: string
      }) =>
        `Cargado: ${employees} empleados, ${risks} riesgos, ${nonConformities} no conformidades, ${documents} documentos, ${saas} accesos SaaS${skippedList ? ` (${skippedList})` : ''}`,
      TOAST_ERROR: ({ message }: { message: string }) => `La carga de datos de demo falló: ${message}`,
      TOAST_ERROR_GENERIC: 'La carga de datos de demo falló',
      SKIP_REASON_ALREADY_HAS_ASSETS: 'activos ya presentes',
      SKIP_REASON_ALREADY_HAS_RISKS: 'riesgos ya presentes',
      SKIP_REASON_ALREADY_HAS_NCS: 'no conformidades ya presentes',
      SKIP_REASON_ALREADY_HAS_DEPARTMENTS: 'departamentos ya presentes',
      SKIP_REASON_ALREADY_HAS_SUPPLIERS: 'proveedores ya presentes',
      SKIP_REASON_ALREADY_HAS_TRUST_CENTER: 'trust center ya presente',
      SKIP_REASON_ALREADY_HAS_TASKS: 'tareas ya presentes',
      SKIP_REASON_ALREADY_HAS_TEXT_DOCUMENTS: 'documentos ya presentes',
      SKIP_REASON_ALREADY_WITHIN_DEMO_SCOPE: 'alcance ya recortado',
      SKIP_REASON_ALREADY_HAS_EASM_DATA: 'datos EASM ya presentes',
      SKIP_REASON_ALREADY_HAS_CSPM_DATA: 'datos CSPM ya presentes',
    },
  },
  COLUMNS: {
    TENANT: 'Tenant',
    STANDARDS: 'Estándares',
    ARR: 'ARR',
    SECURITY_MANAGER: 'Security Manager',
    ONBOARDING: 'Onboarding',
    ONBOARDING_TIME: 'Tiempo de onboarding',
    ADOPTION_RATE: 'Adopción',
    TIME_TO_AUDIT: 'Tiempo a auditoría',
    STATUS: 'Estado',
  },
  STATUS: {
    ONBOARDING: 'Onboarding',
    LIVE: 'Activo',
    AT_RISK: 'En riesgo',
    CHURN: 'Baja',
    NOT_PRODUCTION: 'Cuenta no productiva',
    DEMO: 'Cuenta demo',
    NOT_SET: 'Sin definir',
  },
}
